import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { CDropdown, CDropdownItem, CDropdownMenu, CDropdownHeader, CDropdownToggle, CImage, CNavLink } from '@coreui/react-pro';

import { signOut } from '../../helpers/auth';
import { SUBSCRIBER_PATH, SYSTEM_ADMIN_PATH } from '../../constants';
import { setOverlay } from '../../actions/general';

const SystemAdminAccountDropdown = () => {
     const dispatch = useDispatch();
     const navigate = useNavigate();

     const [dropdownProps, setDropdownProps] = useState({
          onBlurEnabled: false,
          isDropdownItemFocusing: false,
     });
     const user = useSelector((state) => state.subscriber.user);

     const toggleShow = () => {
          const dropdownClass = document.getElementsByClassName('user-nav-item')[0].className;

          if (dropdownClass.includes('show')) {
               setDropdownProps({ onBlurEnabled: false, isDropdownItemFocusing: false });
               dispatch(setOverlay(false));
          } else {
               setDropdownProps({ onBlurEnabled: true, isDropdownItemFocusing: false });
               dispatch(setOverlay(true));
          }
     };

     const handleVisitSite = () => {
          navigate(SUBSCRIBER_PATH.SELLING_GROUPS);
          setTimeout(() => {
               window.location.reload(true);
          }, 100);
     };

     const handleDropdownMenuFocus = () => {
          setDropdownProps({ onBlurEnabled: true, isDropdownItemFocusing: true });
          dispatch(setOverlay(true));
     };

     return (
          <CDropdown className="header-nav-items user-nav-item" variant="nav-item" alignment="end" autoClose="outside">
               <CDropdownToggle
                    className="header-nav-link"
                    caret={false}
                    onClick={toggleShow}
                    onBlur={dropdownProps.onBlurEnabled ? toggleShow : null}
               >
                    <div className="avatar avatar-md">
                         <CImage src="/assets/images/user-default-avatar.png" className="avatar-img" alt="user-avatar" />
                    </div>
               </CDropdownToggle>
               <CDropdownMenu
                    className="pt-0 account-dropdown"
                    placement="bottom-end"
                    onBlur={dropdownProps.isDropdownItemFocusing ? toggleShow : null}
               >
                    <CDropdownHeader tag="div" onFocus={handleDropdownMenuFocus}>
                         <span>My Account</span>
                         <p className="account-user-email m-0">{user?.email ?? ''}</p>
                    </CDropdownHeader>
                    <div className="dropdown-item" onClick={handleVisitSite}>
                         <CNavLink to={SUBSCRIBER_PATH.SELLING_GROUPS} component={NavLink}>
                              Visit Site
                         </CNavLink>
                    </div>
                    <div className="dropdown-item">
                         <CNavLink to={SYSTEM_ADMIN_PATH.PROFILE} component={NavLink} className="signin-link">
                              My Profile
                         </CNavLink>
                    </div>
                    <CDropdownItem className="sign-out text-danger" onClick={signOut}>
                         SIGN OUT
                    </CDropdownItem>
               </CDropdownMenu>
          </CDropdown>
     );
};

export default SystemAdminAccountDropdown;
